export const RazorpayConstants = {
    "CompanyName": "Chefkart Hospitality Pvt. Ltd.",
    "Description": "Chefkart Subscription Fees",
    "Currency": "INR",
    "Theme": {
        "color": "#FFB11D"
    }
}